import React from "react";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {Button, convertInputFormToObject, InputForm, inputStyles, useInputForm} from "../../../../Components/Inputs";
import {clearInputFormFields} from "../../../../Components/Inputs/inputUtility";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";

interface OwnLoanSearchFormViewProps {
    ownLoanSearchCriteria: Record<string, any>;
    ownLoanSearchDropDowns: Record<string, any>;
    handleSetOwnLoanSearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
}

export const OwnLoanSearchFormView = ({
                                          ownLoanSearchCriteria,
                                          ownLoanSearchDropDowns,
                                          handleSetOwnLoanSearchCriteria,
                                          isLoading,
                                      }: OwnLoanSearchFormViewProps) => {

    const searchForm = useInputForm(ownLoanSearchCriteria);

    const patrons = createListFromArrayOfObjects(ownLoanSearchDropDowns.patrons, "userId", "fullName");
    const shippingLocations = createListFromArrayOfObjects(ownLoanSearchDropDowns.shippingLocations, "shippingLocationId", "name");
    const districts = createListFromArrayOfObjects(ownLoanSearchDropDowns.districts, "districtId", "districtName");
    const organizations = createListFromArray(ownLoanSearchDropDowns?.organizations);

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedLoanSearchCriteria = {...ownLoanSearchCriteria};
        updatedLoanSearchCriteria.ClearOrderSearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedLoanSearchCriteria = {...ownLoanSearchCriteria};
        updatedLoanSearchCriteria.Search(criteria);
        handleSetOwnLoanSearchCriteria(updatedLoanSearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.FOUR,
    };

    return <>
        <InputForm name={"loanSearch"} hasPaddingY>

            <SearchableSingleSelectField
                {...searchForm.patronId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Patron'}
                options={patrons}
            />

            <SearchableSingleSelectField
                {...searchForm.shippingLocationId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Shipping Locations'}
                options={shippingLocations}
            />

            <SearchableSingleSelectField
                {...searchForm.districtId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'District'}
                options={districts}
            />

            <SearchableSingleSelectField
                {...searchForm.organization}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Organization'}
                options={organizations}
            />

            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            label="Search"
                            name="btnSearchLoan"
                            onClick={handleSearchClick}
                            isPrimary
                        />
                    </GridCell>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            name="btnClearLoanSearch"
                            onClick={handleClearClick}
                            label="Clear"
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>;
};
